import Swiper, { Pagination } from "swiper";

(() => {
  new Swiper(".kw-read-more-swiper", {
    modules: [Pagination],
    spaceBetween: 20,
    autoHeight: true,
    slidesPerView: 1,
    resizeObserver: true,
    pagination: {
      el: ".kw-read-more-swiper>.swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: "auto",
        autoHeight: false,
      },
      990: {
        slidesPerView: 3,
      },
      1080: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
      1920: {
        spaceBetween: 43,
        slidesPerView: 3,
      },
    },
    on: {
      resize: function (sw) {
        sw.updateAutoHeight(400);
      },
    },
  });
})();
